
<template>
    <div>
        <div>
            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="container" v-if="! isLoadingBlade">
                <div class="row">
                    <div class="col-lg-2">
                        <base-input alternative="">
                            <select
                                class="form-control form-control-alternative"
                                v-model="page"
                                @change="getPageItems()"
                            >
                                <option
                                    v-for="number in pageNumbers"
                                    :key="number"
                                    :value="number"
                                >
                                    {{ number }}
                                </option>
                            </select>
                        </base-input>
                    </div>
                    <div class="col-lg-10 text-right">
                        <div class="row" v-if="! hasExportPages">
                            <div :class="'col-lg-'+(hasRecords ? 9 : 12)">
                                <form :action="getRootUrl+'/export-attachment-report'" method="POST">
                                    <input
                                        v-for="(value, item) in filters"
                                        v-if="(item != 'limit')"
                                        :key="item"
                                        type="hidden"
                                        :name="item"
                                        :value="value"
                                    />

                                    <input
                                        type="hidden"
                                        name="admin_id"
                                        :value="user.id"
                                    />

                                    <button
                                        :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                        :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                        @click="displayFilters()"
                                    >
                                        <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                        {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                                    </button>

                                    <button
                                        class="btn btn-lg btn-success"
                                        nativeType="submit"
                                        v-if="records && records.length > 0"
                                        :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                    >
                                        <i class="fa fa-file-export"></i>
                                        Export Report
                                    </button>
                                </form>
                            </div>

                            <div class="col-lg-3" v-if="hasRecords">
                                <!-- export with photo button -->
                                <form :action="getRootUrl+'/export-attachment-report'" method="POST">
                                    <input
                                        v-for="(value, item) in filters"
                                        v-if="(item != 'limit')"
                                        :key="item"
                                        type="hidden"
                                        :name="item"
                                        :value="value"
                                    />

                                    <input type="hidden" name="admin_id" :value="user.id" />

                                    <input type="hidden" name="option" value="photo" />

                                    <button
                                        class="btn btn-lg btn-success"
                                        nativeType="submit"
                                        :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                    >
                                        <i class="fa fa-file-export"></i>
                                        Export with Photo
                                    </button>
                                </form>
                            </div>
                        </div>
                        
                        <!-- if many records button -->
                        <div v-if="hasExportPages">
                            <button
                                :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayFilters()"
                            >
                                <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                            </button>
                            <button
                                :class="'btn btn-lg btn-'+ (showExportPages ? 'danger' : 'success')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayExportPages()"
                            >
                                <i :class="'fa fa-'+(showExportPages ? 'times' : 'sort')"></i>
                                {{ showExportPages ? 'Remove Export Pages' : 'Show Export Pages'}}
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-12" v-if="hasExportPages && showExportPages">
                        <hr>
                        <form :action="getRootUrl+'/export-attachment-report'" method="POST">
                            <input
                                v-if="(item != 'limit')"
                                v-for="(value, item) in filters"
                                :key="item"
                                type="hidden"
                                :name="item"
                                :value="value"
                            />

                            <input
                                type="hidden"
                                name="admin_id"
                                :value="user.id"
                            />

                            <input
                                type="hidden"
                                name="limit"
                                :value="exportPerSheet"
                            />

                            <div class="col-lg-12 text-center">
                                <h3 class="text-danger">
                                    Note: Maximum of {{ exportPerSheet }} record(s) per export.
                                </h3>
                                <hr>
                            </div>

                            <div class="row">
                                <div class="col-lg-6">                                
                                    <base-input label="Select Range of Records" required>
                                        <select
                                            class="form-control form-control-alternative"
                                            name="export_page"
                                            required
                                        >
                                            <option  value="null" disabled selected>
                                                ---Select One---
                                            </option>
                                            <option
                                                v-for="page in exportPages"
                                                :key="page"
                                                :value="page"
                                            >
                                                Page {{ page }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>

                                <div class="col-lg-6">
                                    <base-input label="Export with Photo" required>
                                        <select
                                            class="form-control form-control-alternative"
                                            name="option"
                                            @change="enableExportPageButton()"
                                            required
                                        >
                                            <option :value="null" disabled selected>
                                                ---Select One---
                                            </option>
                                            <option value="photo">Yes</option>
                                            <option value="exam">No</option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>

                            <button
                                class="btn btn-lg btn-success btn-block"
                                style="margin-top: 10px;"
                                nativeType="submit"
                                v-if="records && records.length > 0"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges || disableExportPageButton"
                            >
                                <i class="fa fa-file-export"></i>
                                Export Page
                            </button>
                        </form>
                        <hr>
                    </div>
                </div>
            </div>

            <div class="container" v-if="showFilters && ! isLoadingBlade">
                <hr>
                <h3 class="mb-0 text-uppercase text-center" v-html="filteredTitle"></h3>
                <hr v-if="! isFiltered">
                <div class="row" v-if="! isFiltered">

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Attachment Batch"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.batch"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option
                                    class="text-capitalize"
                                    v-for="batch in batches"
                                    :key="batch.id"
                                    :value="batch.id"
                                >
                                    {{ batch.name +' - '+ batch.code+' ('+ batch.year +')' }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Attachment Centre"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.centre"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option
                                    class="text-capitalize"
                                    v-for="centre in centres"
                                    :key="centre.id"
                                    :value="centre.id"
                                >
                                    {{ centre.name }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Training Type"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.training_type"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="medical">Medical Training</option>
                                <option value="dental">Dental Training</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Exam Year"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.year"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option
                                    v-for="year in years"
                                    :key="year"
                                    :value="year"
                                >
                                    {{ year }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Application Status"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.status"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="submitted">Submitted</option>
                                <option value="rejected">Rejected</option>
                                <option value="awaiting-posting">Awaiting Posting</option>
                                <option value="posted">Posted</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Training Status"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.training_status"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="awaiting-payment">Awaiting Payment</option>
                                <option value="paid">Paid</option>
                                <option value="resumed">Resumed</option>
                                <option value="completed">Completed</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            label="Payment Date Range"
                        >
                            <flat-picker
                                slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                v-model="filters.date_range"
                                :config="{allowInput: true, mode: 'range'}"
                                class="form-control datepicker"
                            >
                            </flat-picker>
                        </base-input>
                    </div>

                    <div class="col-lg-12">
                        <button
                            class="btn btn-lg btn-info btn-block"
                            :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            @click="applyFilters()"
                        >
                            <i class="fa fa-check"></i>
                            Apply Filters
                        </button>
                        <button
                            class="btn btn-lg btn-danger btn-block"
                            @click="displayFilters()"
                        >
                            <i class="fa fa-times"></i>
                            Remove Filters
                        </button>
                    </div>
                </div>
                <hr>
            </div>

            <!-- import Payment Report Data template here -->
            <ReportingData
                :records="records"
                :hasPagination="hasPagination"
                :pagination="pagination"
                :paginate="paginate"
                :privileges="privileges"
                :totalAmount="totalAmount"
                :replaceAll="replaceAll"
                v-if="! isLoadingBlade"
            />

        </div>

        <div
            class="col-sm-12 text-center"
            v-if="showErrorStatus && ! isLoadingBlade"
        >
            <base-alert :type="errorType">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>

    </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import ReportingData from './ReportingData';
  import swal from 'sweetalert2';// import sweet alert

  export default {
    name: 'Reporting',
    props: ['privileges'],
    components: {
        ReportingData,
        flatPicker
    },
    data() {
      return {
        payment: [],
        showErrorStatus: false,
        errorType: null,
        errorMsg: null,
        isLoadingBlade: true,
        records: [],
        paginatedItems: [],
        pagination: {
            total: null,
            prev_page_url: null,
            next_page_url: null,
            current_page: null,
            last_page: null,
            number: 1,
            from: 0,
            to: null,
            perPage: this.$store.state.url.perPage // get per page count
        },
        filters: {
            batch: null,
            centre: null,
            training_type: null,
            status: null,
            training_status: null,
            year: null,
            date_range: null,
            limit: this.$store.state.url.perPage // get per page count
        },
        totalAmount: null,
        batches: [],
        centres: [],
        page: 1,
        showFilters: false,
        isFiltered: false,
        showExportPages: false,
        disableExportPageButton: true,
        filteredTitle: 'Filtered Attachment Program Report',
      }
    },
    filters: {
        formatDate(value) {
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
    },
    computed: {
        ...mapGetters(['loadingBladeUrl', 'getRootUrl', 'user', 'exportPerSheet']),
        hasPagination() {
            return this.pagination.next_page_url || this.pagination.prev_page_url ? true : false;
        },
        pageNumbers() {
            let start = 1;
            let end = this.pagination.last_page;
            let pages = [];
            for (let i = start; i <= end; i++ ) {
                pages.push(i);
            }
            return pages;
        },
        hasExportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            return this.pagination.total > divider;
        },
        exportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            let pages = Math.ceil(this.pagination.total / divider);
            return pages;
        },
        years() {
            let startYear = moment().format('YYYY') -32;// start from 1900
            let currentYear = parseInt(moment().format('YYYY')) + 1;
            let years = [];
            for (let i = currentYear; i > startYear; i-- ) {
                years.push(i);
            }
            return years;
        },
        hasRecords() {
            return this.records && this.records.length > 0;
        }
    },
    methods: {
        ...mapActions(['getAttachmentPayments', 'getPaginatedPaymentItems']),
        applyFilters() {// apply filters function
            let status = this.validFilterInputs();
            this.showErrorStatus = false;
            if(status) {
                this.preloader();// show loading
                let data = this.filters;
                data.filter = true;
                this.getAttachmentPayments(data).then((res) => {// get transactions
                    this.isLoadingBlade = false;
                    this.setPages(res);//set data
                    this.isFiltered = true;
                    this.getFilteredTitle();// set filtered title
                    swal.close();
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                let msg = 'Kindly select one of the filter actions, and try again';
                swal.fire('Invalid Selection', msg, 'warning');
            }
        },
        getFilteredTitle() {// set filtered payment title
            let data = this.filters;
            if(data.batch) {
                let batch = this.batches.filter(item => item.id == data.batch)[0];
                this.filteredTitle += batch ?  `, Assessment Batch -> <em class="text-danger">
                                    ${batch.title} - ${batch.description} (${batch.year})</em>` : '';
            }
            if(data.centre) {
                let centre = this.centres.filter(item => item.id == data.centre)[0];
                this.filteredTitle += centre ?  `, Attachment Centre -> <em class="text-danger">${centre.name}</em>` : '';
            }
            this.filteredTitle += data.training_type ?  `, Training Type -> <em class="text-danger">${data.training_type}</em>` : '';
            this.filteredTitle += data.year ?  `, Exam Year -> <em class="text-danger">${data.year}</em>` : '';
            this.filteredTitle += data.status ?  `, Application Status -> <em class="text-danger">${data.status}</em>` : '';
            this.filteredTitle += data.training_status ?  `, Training Status -> <em class="text-danger">
                                    ${this.replaceAll(data.training_status, '-', ' ')}</em>` : '';
            if(data.date_range) {// Add date range to title
                let date = data.date_range.split('to');
                let from = this.formatRangeDate(date[0]);
                let to = this.formatRangeDate(date[1]);// eslint-disable-next-line
                this.filteredTitle += `<br><em><small>(${from} to ${to})</small></em>`;
            }
            this.filteredTitle += ' <br>Applications Only';
        },
        replaceAll(str, find, replace) {
            return str.replace(new RegExp(find, 'g'), replace);
        },
        formatRangeDate(value) {// format range date
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
        validFilterInputs() {
            let data = this.filters;
            return data.batch || data.training_type || data.status || data.date_range || data.year 
                    || data.training_status || data.centre;
        },
        displayFilters() {// diplay filters template
            this.emptyFilters();// empty filters
            this.loadApplications();// reload payments
            this.showExportPages = false;
            return this.showFilters = ! this.showFilters;
        },
        emptyFilters() {// empty filters
            this.filters = {
                batch: null,
                centre: null,
                training_type: null,
                status: null,
                year: null,
                date_range: null,
                training_status: null,
                limit: this.$store.state.url.perPage // get per page count
            };
            this.isFiltered = false;
            this.filteredTitle = 'Filtered Attachment Program Report';
            this.totalAmount = null;
        },
        loadApplications() {// load details
            let data = { limit : this.pagination.perPage, filter : false };
            this.isLoadingBlade = true;
            this.showErrorStatus = false;
            this.getAttachmentPayments(data).then((res) => {// get users
                this.isLoadingBlade = false;
                this.setPages(res);//set data
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        setPages(data) {// set paginated function
            this.totalAmount = data.total_amount;// get total amount
            this.batches = data.batches;
            this.centres = data.centres;
            let res = data.payments;
            this.records = [];
            this.paginatedItems = res.data;
            this.records = this.paginatedItems;
            this.pagination.from = res.from;
            this.pagination.to = res.to;
            this.pagination.total = res.total;
            this.pagination.current_page = res.current_page;
            this.pagination.last_page = res.last_page;
            this.pagination.prev_page_url = res.prev_page_url;
            this.pagination.next_page_url = res.next_page_url;
            this.isLoadingBlade = false;
            this.emptyRecordsMsg();//show empty msg
        },
        paginate() {// paginate function
            this.showErrorStatus = false;
            let url = (this.pagination.number > this.pagination.current_page) ?
                this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {// make api call
                this.isLoadingBlade = true
                this.getPaginatedPaymentItems(url).then((res) => {// get users
                    this.pagination.number = res.payments.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.users = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
            }
        },
        emptyRecordsMsg() {
            return this.records && this.records.length == 0 ? this.showEmptyMsg() : false;
        },
        showEmptyMsg() {// show empty msg
            this.showErrorStatus = true;
            this.errorType = 'warning';
            this.errorMsg = 'No Applications recorded yet!!!';
        },
        displayExportPages() {
            this.showFilters = false;
            return this.showExportPages = ! this.showExportPages;
        },
        getPageItems() {
            let url = this.pagination.next_page_url ?
                        this.pagination.next_page_url : this.pagination.prev_page_url;
            let exploded = url.split('&');
            let newUrl = exploded[0]+'&'+exploded[1]+'&'+exploded[2]+'&'+exploded[3]+'&page='+this.page;
            this.isLoadingBlade = true
            this.getPaginatedPaymentItems(newUrl).then((res) => {// get records
                this.pagination.number = res.payments.current_page;
                this.setPages(res);
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        enableExportPageButton() {
            return this.disableExportPageButton = false;
        },
        preloader() {
            return  swal.fire({
                title: 'Please Wait...',
                html: 'Trying to fetch data from <b>server</b>',
                // timer: 2000,
                timerProgressBar: true,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });
        }
    },
    mounted() {
        this.loadApplications();
    }
  };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
